/**
 * @generated SignedSource<<3244ae8351bbf49f2ef15f36fa9999ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TitleColumnPublishedNodes_PublishedNodesFragment$data = {
  readonly structureDefinition: {
    readonly title: string;
  };
  readonly " $fragmentType": "TitleColumnPublishedNodes_PublishedNodesFragment";
};
export type TitleColumnPublishedNodes_PublishedNodesFragment$key = {
  readonly " $data"?: TitleColumnPublishedNodes_PublishedNodesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TitleColumnPublishedNodes_PublishedNodesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TitleColumnPublishedNodes_PublishedNodesFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "structureDefinition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LearnOpportunityV2",
  "abstractKey": null
};

(node as any).hash = "1c5679292f0501c6c8a360456acea668";

export default node;
